<template>
  <div>
    <ValidationObserver ref="validator" slim v-slot="{ handleSubmit, passed }">
      <p class="lib__text-weight-700">{{ $t('meter-box.yourGasMeter') }}</p>
      <div class="row">
        <div v-if="isHouseSelected" class="col-xs-12 col-sm-4 col-md-4 lib__field">
          <p class="lib__field__label">{{ $t('meter.form.count') }}</p>
          <h4>
            {{ meter.count }}
          </h4>
        </div>
        <div v-if="!isHouseSelected" class="col-xs-12 col-md-4">
          <number-box :label="$t('meter.form.count')" :min="1" :max="99" :step="1" required
            v-model="meter.count" ></number-box>
        </div>
        <div class="col-xs-12 col-md-8">
          <select-box :label="$t('meter.form.tension')"
            :options="technicalCharacteristics.map(c => { return { text: $t('meter.tension.' + c), value: c } })"
            required v-model="meter.technicalCharacteristic"></select-box>
        </div>
        <div v-if="meter.technicalCharacteristic === 'standard'" class="col-xs-12 lib__field">
          <p class="lib__field__label">
            {{ $t('meter.form.maximumPowerGuaranteed') }}
            </p>
          <h4>
            {{ meter.power }}
          </h4>
        </div>
        <div v-if="meter.technicalCharacteristic === 'custom'" class="col-xs-12">
          <number-box :label="$t('meter.form.maximumPowerWanted')"
            :min="1" :max="isGasManagerResa ? 150 : 9999" :step="1" required v-model="meter.power">
          </number-box>
          <error-message v-if="isGasManagerResa && meter.technicalCharacteristic === 'custom' && meter.power > 150"
            :error="$t('meter.form.maximumPowerWantedForResa')" />
        </div>
      </div>
      <collapsable-text-area :max='500' :add-label="$t('meter.form.remarks')" :label="$t('meter.form.remarks')"
        v-model="meter.remarks"></collapsable-text-area>
      <div class="lib__text-center">
        <a :class="{ 'lib__btn--disabled': !passed }" @click="handleSubmit(validateMeter)"
          class="lib__btn lib__btn--primary lib__btn--rounded" href="#">
          <slot>
            <i class="fas fa-check"></i>
            <span>{{ $t('common.confirm') }}</span>
          </slot>
        </a>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { GasMeter, MeterGasTechnicalCharacteristic } from '@/models'
import { helper } from '@/services'
import { Getter } from 'vuex-class'

@Component({
  name: 'cmh-gas-popup-form'
})
export default class CmhGasPopupForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public gasMeter!: GasMeter
  // @Prop({ type: Array, required: true }) public destinations!: MeterDestination[]
  @Prop({ type: Array, required: true }) public technicalCharacteristics!: MeterGasTechnicalCharacteristic[]
  @Prop({ type: Boolean, required: true }) public isHouseSelected!: boolean
  //#endregion*

  @Getter('isGasManagerResa', { namespace: 'newConnectionCmh/cmhAddress' })
  private isGasManagerResa!: boolean

  //#region [Data]
  public meter: GasMeter = {
    count: 1,
    technicalCharacteristic: 'standard',
    destination: 'residential',
    power: 60,
    remarks: null
  }
  //#endregion

  //#region [Method]
  public mounted() {
    if (this.gasMeter != null) {
      this.meter = helper.clone(this.gasMeter)
    }
  }

  public validateMeter() {
    this.$emit('validateMeter', this.meter)
  }
  //#endregion

  //#region [Watch]
  @Watch('gasMeter')
  public gasMeterChange(value: GasMeter) {
    this.meter = helper.clone(this.gasMeter)
  }

  @Watch('meter.technicalCharacteristic')
  public onTechnicalCharacteristicChanged(newVal: MeterGasTechnicalCharacteristic) {
    if (newVal === 'standard') {
      this.meter.power = 60
    }
  }
  //#endregion
}
</script>
